import { aperturaStore, AperturaStore } from './aperturaStore';
import { aprobacionStore, AprobacionStore } from './aprobacionStore';
import { authStore, AuthStore } from './authStore';
import { capturaStore, CapturaStore } from './capturaStore';
import { consultaStore } from './consultaStore';
import {encryptStore, EncryptStore} from './encryptStore';
import { notificationStore, NotificationStore } from './notificationStore';
import { requestStore, RequestStore } from './requestStore';
import {tokenStore, TokenStore} from './tokenStore';
import { userStore, UserStore } from './userStore';

import {
    impuestosPredialCuentasStore,
    ImpuestosPredialCuentasStore
} from './impuestosPredialCuentasStore';
import {
    impuestosPredialDescuentosStore,
    impuestosPredialIngresosStore,
    ImpuestosPredialDesgloseStore
} from './impuestosPredialDesgloseStore';
import {
    registroImpuestosPredialStore,
    RegistroImpuestosPredialStore
} from './registroImpuestosPredialStore';

import {
    impuestosAguaDescuentosStore,
    impuestosAguaIngresosStore,
    ImpuestosAguaDesgloseStore
} from './impuestosAguaDesgloseStore';
import {
    impuestosAguaCuentasStore,
    impuestosAguaPorUsoStore,
    ImpuestosAguaMedidorStore
} from './impuestosAguaMedidorStore';
import {
    registroImpuestosAguaStore,
    RegistroImpuestosAguaStore
} from './registroImpuestosAguaStore';

export {
    AperturaStore,
    AprobacionStore,
    AuthStore,
    CapturaStore,
    consultaStore,
    EncryptStore,
    RequestStore,
    UserStore,
    ImpuestosPredialCuentasStore,
    ImpuestosPredialDesgloseStore,
    RegistroImpuestosPredialStore,
    ImpuestosAguaDesgloseStore,
    ImpuestosAguaMedidorStore,
    RegistroImpuestosAguaStore,
    TokenStore,
    NotificationStore
};

export const stores = {
    aperturaStore,
    aprobacionStore,
    authStore,
    capturaStore,
    consultaStore,
    encryptStore,
    requestStore,
    userStore,
    impuestosAguaCuentasStore,
    impuestosAguaDescuentosStore,
    impuestosAguaIngresosStore,
    impuestosAguaPorUsoStore,
    impuestosPredialCuentasStore,
    impuestosPredialDescuentosStore,
    impuestosPredialIngresosStore,
    registroImpuestosAguaStore,
    registroImpuestosPredialStore,
    tokenStore,
    notificationStore
};
